import { render, staticRenderFns } from "./TeachingCenterIndex.vue?vue&type=template&id=6893e98b&scoped=true&"
import script from "./TeachingCenterIndex.vue?vue&type=script&lang=js&"
export * from "./TeachingCenterIndex.vue?vue&type=script&lang=js&"
import style0 from "./TeachingCenterIndex.vue?vue&type=style&index=0&id=6893e98b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6893e98b",
  null
  
)

export default component.exports